import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Contact } from './../Contact';
import { HomeContactTel } from './../HomeContactTel';
import { MasterViewPage } from './../MasterPage';
import { SeoStuff } from './../SeoStuff';


export const PubRedressissement = () => {
    return <MasterViewPage>
        <Box sx={{ backgroundImage: "url('images/redressisement_noir_et_blanc.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <Box className='dark header'>
                <Container sx={{ opacity: 1, pt: { xs: 4, sm: 4, md: 4, lg: 8 }, pb: { xs: 1, sm: 1, md: 3, lg: 5 }, textAlign: 'center', textShadow: '0px 0px 5px black' }}>
                    <Typography variant='h3'>Près de <strong>20 ans</strong> d'expertise en <strong className='white'>redressement</strong> et <strong className='white'>mise à niveau</strong> de maison.</Typography>
                    <Typography sx={{ maxWidth: 560, margin: '0 auto' }}>Nos <strong className='white'>pieux hydrauliques</strong> permettent de mettre à niveau même les structures les plus lourdes. Si vous voyez des signes comme des <strong className='white'>fissures dans vos fondations</strong> ou des <strong>portes et fenêtres qui ferment mal</strong>, il est temps d'agir. Votre maison est un <strong>investissement majeur</strong> — ne laissez pas ces dommages <strong className='white'>s’aggraver</strong>.</Typography>
                    <Typography variant='h4' sx={{ maxWidth: 560, margin: '0 auto' }}>Contactez-nous pour <strong>LA</strong> solution <strong className='white'>durable</strong> et <strong className='white'>garantie</strong> !</Typography>
                    <Box component='img' alt='Logo Pieux Protech' title='Logo Pieux Protech' src="/images/PieuxProTechBlanc.png" sx={{ maxHeight: '120px' }}></Box>
                </Container>
            </Box>
        </Box>
        <div className='dark'>
            <Container><Box component='img' src='images/image-stabilisation-maison.jpg' sx={{ width: '100%' }} />
            </Container>
        </div>
        <Contact />
        <div className="dark"><HomeContactTel /></div>
        <SeoStuff />
    </MasterViewPage >;
};
